
import React from "react";
import Link from "@mui/material/Link";
import { Email } from "@mui/icons-material";


export const ButtonMailto: React.FC<{
    label: string;
    recipient: string;
    subject?: string;
    content?: string;
}> = ({ label, recipient, subject, content }) => {
    const mailto = `mailto:${recipient}?subject=${encodeURIComponent(subject ?? 'No subject')}&body=${encodeURIComponent(content ?? 'No information provided')}`;
    return (
        <Link
            href={mailto}
            underline="hover"
            color="inherit" 
            fontWeight='inherit'           
            sx={{
                marginX: '1em',
                cursor: 'pointer',
                textDecoration: 'none',
                "&:hover": { textDecoration: 'underline' }
            }}
        >
            <Email />&nbsp;<b>{label}</b>
        </Link>
    );
};

export default ButtonMailto;